<div *ngIf="dataSource$ | async as dataSource" style="display: flex; flex-direction: column; height: 100%;">
  <div style="flex-grow: 1; overflow: auto; padding: 0 35px;">
    <div *ngIf="dataSource.data.length > 0" style="overflow: visible;">
      <table mat-table [dataSource]="dataSource" class="table-width"
             [trackBy]="trackByFn" style="width: 100%; border-spacing: 0 3px; background: transparent;">
        <ng-container matColumnDef="caseName">
          <th mat-header-cell *matHeaderCellDef style="width: 15%; font-size: 14px">Case</th>
          <td mat-cell *matCellDef="let element" [style.height.px]="rowHeight$ | async" style="font-size: 14px">{{element.caseName}}</td>
        </ng-container>
        <ng-container matColumnDef="functionName">
          <th mat-header-cell *matHeaderCellDef style="width: 5%; font-size: 14px">Step</th>
          <td mat-cell *matCellDef="let element" [style.height.px]="rowHeight$ | async" style="font-size: 14px">{{element.stepName}}</td>
        </ng-container>
        <ng-container matColumnDef="functionCount">
          <th mat-header-cell *matHeaderCellDef style="width: 10%; font-size: 14px">Count</th>
          <td mat-cell *matCellDef="let element" [style.height.px]="rowHeight$ | async" style="font-size: 14px">{{element.stepCount | number}}</td>
        </ng-container>
        <ng-container matColumnDef="accountName">
          <th mat-header-cell *matHeaderCellDef style="width: 10%; font-size: 14px">Account</th>
          <td mat-cell *matCellDef="let element" [style.height.px]="rowHeight$ | async" style="font-size: 14px">{{element.accountName}}</td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
        <tr [@rowTransitionAnimation]="{ value: '', params: { delay: i * 100 } }" mat-row *matRowDef="let row; let i = index; columns:columnsToDisplay" [style.height.px]="rowHeight$ | async"></tr>
      </table>
    </div>
    <div *ngIf="dataSource.data.length < 1">
      <div style="display: flex; justify-content: center; align-items: center; width: 100%; height: 450px; font-size: 20px;">
        <span class="fal fa-microchip"></span>
        <span style="padding-left: 10px;">No Queued Processing Steps.</span>
      </div>
    </div>
  </div>
</div>
